import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { DELETE, GET, PATCH, POST, PUT } from '../../../common/contants'
import { axiosBaseQuery } from '../../baseQuery'

export const shipmentApi = createApi({
  reducerPath: 'shipmentApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['Shipment', 'ShipmentFast', 'DetailShipment'],
  keepUnusedDataFor: 5,
  endpoints: (builder) => ({
    getListShipment: builder.query({
      query: (params) => ({
        url: NetWork.groupOrder,
        method: GET,
        params: params
      }),
      providesTags: (result) => (result ? [{ type: 'Shipment', id: 'LIST' }] : [])
    }),
    getShipmentById: builder.query({
      query: (params: { orderGroupId: number }) => ({
        url: NetWork.groupOrderId(params.orderGroupId),
        method: GET
      }),
      providesTags: (result) => (result ? [{ type: 'DetailShipment', id: 'DETAIL' }] : [])
    }),
    addShipment: builder.mutation({
      query: (data) => ({
        url: NetWork.groupOrder,
        method: POST,
        data: data
      }),
      invalidatesTags: [{ type: 'Shipment', id: 'LIST' }]
    }),
    updateShipment: builder.mutation({
      query: (data) => ({
        url: NetWork.groupOrderId(data.id),
        method: PUT,
        data: data
      }),
      invalidatesTags: [
        { type: 'Shipment', id: 'LIST' },
        { type: 'DetailShipment', id: 'DETAIL' }
      ]
    }),
    updateStatusShipment: builder.mutation({
      query: (data: { id: number; params: { statusGroupOrder: string } }) => ({
        url: NetWork.groupOrderId(data.id),
        method: PATCH,
        params: data.params
      }),
      invalidatesTags: [{ type: 'DetailShipment', id: 'DETAIL' }]
    }),
    updateStatusApprovalShipment: builder.mutation({
      query: (data: { id: number; params: { statusApproval: string; reasonCancel?: string } }) => ({
        url: NetWork.groupOrderApproval(data.id),
        method: PUT,
        params: data.params
      }),
      invalidatesTags: [{ type: 'DetailShipment', id: 'DETAIL' }]
    }),
    deleteShipment: builder.mutation({
      query: (data: { ids: Array<number | string> }) => ({
        url: NetWork.groupOrder,
        method: DELETE,
        data: data
      }),
      invalidatesTags: [{ type: 'Shipment', id: 'LIST' }]
    }),
    addOrderToShipment: builder.mutation({
      query: (data: { orderIds: Array<number | string>; groupOrderId: number | string }) => ({
        url: NetWork.groupOrderAddOrders(data.groupOrderId),
        method: POST,
        data: { orderIds: data.orderIds }
      }),
      invalidatesTags: [{ type: 'DetailShipment', id: 'DETAIL' }]
    }),
    deleteOrderInShipment: builder.mutation({
      query: (data: { orderIds: Array<number | string>; groupOrderId: number | string }) => ({
        url: NetWork.groupOrderDeleteOrders(data.groupOrderId),
        method: POST,
        data: data
      }),
      invalidatesTags: [{ type: 'DetailShipment', id: 'DETAIL' }]
    })
    //Thêm ảnh
    // uploadFileShipment: builder.mutation({
    //   query: (data) => ({
    //     url: NetWork.uploadShipment(data.path),
    //     method: POST,
    //     data: data.values,
    //     headers: { 'Content-Type': 'multipart/form-data' }
    //   })
    // })
  })
})

// Export hooks for usage in functional components
export const {
  useGetListShipmentQuery,
  useDeleteShipmentMutation,
  useAddShipmentMutation,
  useGetShipmentByIdQuery,
  useUpdateShipmentMutation,
  useUpdateStatusShipmentMutation,
  useUpdateStatusApprovalShipmentMutation,
  useAddOrderToShipmentMutation,
  useDeleteOrderInShipmentMutation
} = shipmentApi
